import React from 'react';

export const Team = () => {
  return (
    <section id="team" className="text-center" style={{ padding: '80px 0' }}>
      <div className="container">
        <h2
          style={{
            fontSize: '2.8rem',
            fontWeight: 700,
            marginBottom: '60px',
            fontFamily: "'Perpetua', 'Times New Roman', serif",
          }}
        >
          Our Team
        </h2>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '60px 40px',
          }}
        >
          {/* Milton - slightly larger/prominent */}
          <div
            style={{
              flex: '1 1 380px',
              maxWidth: '460px',
              textAlign: 'center',
            }}
          >
            <img
              src="/profile.jpeg"
              alt="Milton Nduro Kimotho"
              style={{
                width: '100%',
                maxWidth: 380,
                height: '500px',
                objectFit: 'cover',
                borderRadius: '12px',
                boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                marginBottom: '24px',
              }}
            />
            <h3
              style={{ fontSize: '1.9rem', fontWeight: 700, marginBottom: 8 }}
            >
              Milton Nduro Kimotho
            </h3>
            <p
              style={{
                color: '#5ca9fb',
                fontSize: '1.2rem',
                marginBottom: 20,
                fontWeight: 500,
              }}
            >
              Advocate of the High Court of Kenya
            </p>
            <p
              style={{
                fontSize: 17,
                lineHeight: 1.7,
                color: '#444',
                textAlign: 'left',
              }}
            >
              Milton holds a Bachelor of Laws (LL.B.) Degree from Kenyatta
              University and is qualified as an Advocate of the High Court in
              Kenya. He has appeared for clients before the Court of Appeal, the
              High Court, the Employment and Labor Relations Court, the
              Environment and Land Court, and Subordinate Courts. He also
              represents clients before Quasi-Judicial bodies including the
              Business Premises Rent Tribunal, Public Procurement Administrative
              Review Board, and Tax Appeals Tribunal.
              <br />
              <br />
              He advises on general corporate & commercial law, financing, data
              protection, insurance, regulatory compliance, and real estate
              matters with experience across Kenya, Tanzania, DRC, Nigeria,
              Uganda, and Zambia.
            </p>
          </div>

          {/* Pascal */}
          <div
            style={{
              flex: '1 1 380px',
              maxWidth: '460px',
              textAlign: 'center',
            }}
          >
            <img
              src="/pascal.jpeg"
              alt="Pascal Rabii Aketch"
              style={{
                width: '100%',
                maxWidth: 380,
                height: '500px',
                objectFit: 'cover',
                borderRadius: '12px',
                boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                marginBottom: '24px',
              }}
            />
            <h3
              style={{ fontSize: '1.9rem', fontWeight: 700, marginBottom: 8 }}
            >
              Pascal Rabii Aketch
            </h3>
            <p
              style={{
                color: '#5ca9fb',
                fontSize: '1.2rem',
                marginBottom: 20,
                fontWeight: 500,
              }}
            >
              Corporate & Conveyancing Lawyer
            </p>
            <p
              style={{
                fontSize: 17,
                lineHeight: 1.7,
                color: '#444',
                textAlign: 'left',
              }}
            >
              Pascal is a corporate and conveyancing lawyer at NK Advocates. He
              holds a Bachelor’s Degree (LL.B) from Kenyatta University and a
              Postgraduate Diploma from the Kenya School of Law. He is also a
              KASNEB candidate pursuing certifications in Accounting and
              Certified Secretarial Services.
              <br />
              <br />
              In corporate practice, he advises on formation of legal entities,
              corporate governance, shareholder rights, compliance,
              restructuring, contracts, banking, insurance, consumer protection,
              and cross-border trade.
              <br />
              <br />
              In conveyancing, he handles complex transactions including
              transfers, charges, leases, discharges, LCB consents, Sectional
              Properties, and other land law matters.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
